import $ from "jquery";

$(window).on('scroll', () => {
  $('#js-header').css('left', -$(window).scrollLeft())
})